import { render } from "./NewsEventPage.vue?vue&type=template&id=2b1f9574"
import script from "./NewsEventPage.vue?vue&type=script&lang=js"
export * from "./NewsEventPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__